import { apiClient } from "../apiClient";

export const truongApi = {
    getAll: () => apiClient.get(`truong`)
}